import { gql } from "@apollo/client";

// Mutation to trigger job scraping
export const TRIGGER_JOB_SCRAPING = gql`
  mutation TriggerJobScraping {
    triggerJobScraping
  }
`;

// Query to get all job scraping sessions
export const GET_JOB_SCRAPING_SESSIONS = gql`
  query GetJobScrapingSessions($limit: Int = 20, $offset: Int = 0) {
    jobScrapingSessions(limit: $limit, offset: $offset) {
      id
      agencySlugId
      status
      startedAt
      completedAt
      totalWebsites
      totalJobsFound
      totalJobsCreated
      totalJobsSkipped
      totalJobsFailed
      successRate
      errorMessage
      createdAt
      updatedAt
    }
  }
`;

// Query to get a specific job scraping session
export const GET_JOB_SCRAPING_SESSION = gql`
  query GetJobScrapingSession($id: ID!) {
    jobScrapingSession(id: $id) {
      id
      agencySlugId
      status
      startedAt
      completedAt
      totalWebsites
      totalJobsFound
      totalJobsCreated
      totalJobsSkipped
      totalJobsFailed
      successRate
      errorMessage
      createdAt
      updatedAt
    }
  }
`;

// Query to get job scraping progress for a session
export const GET_JOB_SCRAPING_PROGRESS = gql`
  query GetJobScrapingProgress($sessionId: ID!) {
    jobScrapingProgress(sessionId: $sessionId) {
      id
      websiteName
      websiteUrl
      status
      jobUrlsExtracted
      jobsProcessed
      jobsCreated
      jobsSkipped
      jobsFailed
      currentJobUrl
      progressPercent
      estimatedTimeLeft
      startedAt
      completedAt
      errorMessage
    }
  }
`;

// Query to get job scraping results for a session
export const GET_JOB_SCRAPING_RESULTS = gql`
  query GetJobScrapingResults(
    $sessionId: ID!
    $status: JobScrapingResultStatus
    $limit: Int = 50
    $offset: Int = 0
  ) {
    jobScrapingResults(
      sessionId: $sessionId
      status: $status
      limit: $limit
      offset: $offset
    ) {
      id
      sessionId
      progressId
      jobUrl
      status
      moblyzeJobId
      errorMessage
      processingTimeMs
      extractedTitle
      extractedCompany
      extractedLocation
      extractedJobType
      extractedSalaryMin
      extractedSalaryMax
      missingFields
      descriptionLength
      requirementsCount
      responsibilitiesCount
      skillsCount
      benefitsCount
      createdAt
      updatedAt
      moblyzeJob {
        id
        title
        status
        category
        location
        employerName
        createdAt
      }
    }
  }
`;

// Query to get job scraping quality metrics
export const GET_JOB_SCRAPING_QUALITY_METRICS = gql`
  query GetJobScrapingQualityMetrics($sessionId: ID!) {
    jobScrapingQualityMetrics(sessionId: $sessionId) {
      sessionId
      totalJobs
      avgDescriptionLength
      avgRequirementsCount
      avgResponsibilitiesCount
      avgSkillsCount
      avgBenefitsCount
      jobsWithSalaryInfo
      salaryInfoPercentage
      commonMissingFields {
        fieldName
        missingCount
        totalJobs
        missingPercentage
      }
    }
  }
`;

// Query to get missing fields analysis
export const GET_JOB_SCRAPING_MISSING_FIELDS_ANALYSIS = gql`
  query GetJobScrapingMissingFieldsAnalysis($sessionId: ID!) {
    jobScrapingMissingFieldsAnalysis(sessionId: $sessionId) {
      fieldName
      missingCount
      totalJobs
      missingPercentage
    }
  }
`;

// Fragment for job scraping session summary
export const JOB_SCRAPING_SESSION_SUMMARY_FRAGMENT = gql`
  fragment JobScrapingSessionSummary on JobScrapingSessionSummary {
    id
    agencySlugId
    status
    startedAt
    completedAt
    totalWebsites
    totalJobsFound
    totalJobsCreated
    totalJobsSkipped
    totalJobsFailed
    successRate
    errorMessage
    createdAt
    updatedAt
  }
`;

// Fragment for job scraping progress
export const JOB_SCRAPING_PROGRESS_FRAGMENT = gql`
  fragment JobScrapingProgress on JobScrapingWebsiteProgress {
    id
    websiteName
    websiteUrl
    status
    jobUrlsExtracted
    jobsProcessed
    jobsCreated
    jobsSkipped
    jobsFailed
    currentJobUrl
    progressPercent
    estimatedTimeLeft
    startedAt
    completedAt
    errorMessage
  }
`;

// Fragment for job scraping result
export const JOB_SCRAPING_RESULT_FRAGMENT = gql`
  fragment JobScrapingResult on JobScrapingResult {
    id
    sessionId
    progressId
    jobUrl
    status
    moblyzeJobId
    errorMessage
    processingTimeMs
    extractedTitle
    extractedCompany
    extractedLocation
    extractedJobType
    extractedSalaryMin
    extractedSalaryMax
    missingFields
    descriptionLength
    requirementsCount
    responsibilitiesCount
    skillsCount
    benefitsCount
    createdAt
    updatedAt
  }
`;
